.form {
    display: flex;
    flex-direction: column;
    gap: var(--bi-scale-3x);
    align-items: center;
    width: 100%;
    color: var(--bi-color-text);

    .radiogroup {
        position: relative;
        display: flex;
        gap: var(--bi-scale-2x);

        .hiddenRadio {
            position: absolute;
            opacity: 0;
        }

        .radioLabel {
            display: flex;
            align-items: center;
            justify-content: center;
            height: var(--bi-scale-10x);
            width: var(--bi-scale-10x);
            border-radius: var(--bi-radius-full);
            cursor: pointer;
        }

        .hiddenRadio:focus-visible + .radioLabel {
            outline: 3px solid var(--bi-states-focus);
            outline-offset: var(--bi-scale-0-50x);
        }
    }

    .thumbActive {
        color: var(--bi-color-stroke-accent);
    }

    .thumbInactive {
        color: var(--bi-color-text);
    }

    .feedbackLabel {
        font: var(--bi-font-body-xl);
        align-self: flex-start;
        margin: 0;
    }

    .feedbackInput {
        width: 100%;
    }

    .turnstile {
        justify-content: center;

        &:not([hidden]) {
            display: flex;
        }
    }

    .turnstileLoading {
        display: flex;
        align-items: center;
        gap: var(--bi-scale-2x);
        margin: 0;
        font: var(--bi-font-body-small);
        color: var(--bi-color-text-subtle);
    }
}

.alert {
    font: var(--bi-font-body-large);
    justify-self: center;
}
